import { makeStatusMapper } from '../../../../contracts/projects/timeline/makeStatusMapper';

export const toArtefactStatus = makeStatusMapper('generating', 'completed', 'error');

export const toFetchingStatus = makeStatusMapper('fetching', 'completed', 'error');

/** Search blocks that render an error state (`PatientSearchBlock` / `TemplateSearchBlock`). */
export const toSearchingStatus = makeStatusMapper('searching', 'completed', 'error');

/** `CalculatorBlock`. */
export const toCalculatingStatus = makeStatusMapper('calculating', 'completed', 'error');

/** `ClinicalTaskResultBlock` — 'failed' (not 'error'), 'creating' (not 'generating'). */
export const toClinicalTaskStatus = makeStatusMapper('creating', 'completed', 'failed');

/** `CreateTemplateBlock` — 'applying' in-progress state. */
export const toCreateTemplateStatus = makeStatusMapper('applying', 'completed', 'error');
